import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery3BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_3_bar"}/>
}
